import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FwButtonComponent, FwLayoutContextComponent } from '@flywheel-io/vision';

import { AuthService } from '../auth.service';

@Component({
  host: { 'test-id': 'login-error' },
  selector: 'login-error',
  imports: [FwLayoutContextComponent, FwButtonComponent],
  template: `
    <fw-layout-context icon="warning-circle" iconColor="danger" title="Login Error" [description]="message">
      <fw-button leftIcon="rotate-refresh" size="large" variant="outline" (click)="auth.login()">Retry</fw-button>
    </fw-layout-context>
  `,
  styles: [
    `
      :host {
        width: 100vw;
        height: 100vh;
        background: var(--page-light);
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
      }
    `,
  ],
})
export class LoginErrorComponent {
  protected auth = inject(AuthService);
  private route = inject(ActivatedRoute);

  message = this.route.snapshot.queryParamMap.get('message') || 'An unknown error occurred while trying to log in.';
}
